export const routePaths = {
  home: "/",
  admin: {
    dashboard: "/admin",
    addUser: "/admin/add-user",
    editUser: "/admin/edit-user/:id",
    editMilestone: "/admin/edit-milestone/:id",
    createMilestone: "/admin/create-milestone",
    claimRedemption: "/admin/reward-redemption/:id",
    editPatientDetails: "/admin/edit-patient-details/:id",
  },
  patient: {
    dashboard: "/patient",
    profile: "/patient/profile",
    rewardActivity: "/patient/my-reward-activity",
    optInOut: "/onboarding/user-consent",
    carePlan: "/patient/care-plan",
    ultrasound: "/patient/ultrasound",
    learning: "/patient/learning",
    faq: "/patient/faq",
  },
};
